import { render } from "./Racing.vue?vue&type=template&id=5d07e9e2&ts=true"
import script from "./Racing.vue?vue&type=script&lang=ts"
export * from "./Racing.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/hound-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__